import { ajaxPostJson,setParams } from './ajax';
//获取任务数量
export const taskNumber = (params) => {
    return ajaxPostJson(`/fileTask/countUserFinishWordNum`, params,'BaseApi');
};
//获取任务列表
export const getTaskPage = (params) => {
  params.filter=setParams(params.filter)
    return ajaxPostJson(`/fileTask/query_page/my_task`, params,'BaseApi');
};
//获取任务数量
export const getTaskNum = (params) => {
    params = setParams(params);
    return ajaxPostJson(`/fileTask/userIdToTaskClassificationNum`, params,'BaseApi');
};
